import React, { useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Image,
  OverlayTrigger,
  Table,
  Tooltip
} from 'react-bootstrap'
import moment from 'moment'
import SpinnerLoading from '../../../spinner-loading'
import { BsCheckCircleFill, BsCircleFill } from 'react-icons/bs'
import ModalCancel from '../ModalCancel'
import UseResignOption from '../../../../hooks/use-resign-option'
import cancelImg from '../../../../images/Cancel.svg'
import cancelImg2 from '../../../../images/Cancel2.svg'
import editImg from '../../../../images/Edit.svg'
import editImg2 from '../../../../images/Edit2.svg'
import editImg3 from '../../../../images/EditSecondary.svg'
import sortDown from '../../../../images/sort-down.svg'
import sortUp from '../../../../images/sort-up-alt.svg'
import { useSelector } from 'react-redux'

export default function TableListResignPD({
  dataChecklist,
  page,
  totalLimits,
  isLoading,
  hadleClickIT,
  hadleClickPD,
  hadleClickAdmin,
  getChecklistResign,
  sortDoc,
  sortCode,
  sortLastDate,
  sortName,
  handleSortDoc,
  handleSortCode,
  handleSortLastDate,
  handleSortName,
  clickedColumn,
  statusId,
  orgId
}) {
  const [openCancel, setOpenCancel] = useState(false)
  const [detailById, setDetailById] = useState()
  const resignsOption = UseResignOption()
  const fnCancelCLN = (data) => {
    setOpenCancel(true)
    setDetailById(data)
  }
  const onCancel = () => setOpenCancel(false)

  return (
    <>
      <ModalCancel
        fnData={getChecklistResign}
        resignsOption={resignsOption}
        data={detailById}
        open={openCancel}
        onCancel={onCancel}
        page={page}
        statusId={statusId}
      />
      <>
        <Table hover className="mb-3">
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px', zIndex: 10 }}
          >
            <tr className="font-title-table">
              <th className="fw-normal " style={{ whiteSpace: 'nowrap' }}>
                #
              </th>
              <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                {clickedColumn === 'clrNo' ? (
                  <span
                    style={
                      clickedColumn === 'clnNo'
                        ? {
                            borderRadius: '2px',
                            border: '1px solid black',
                            padding: 2,
                            marginRight: 2
                          }
                        : {}
                    }
                  >
                    <Image
                      className="fw-normal"
                      src={sortDoc ? sortDown : sortUp}
                      onClick={() => handleSortDoc('clnNo')}
                    />
                  </span>
                ) : (
                  <Image
                    className="fw-normal"
                    src={sortUp}
                    onClick={() => handleSortDoc('clnNo')}
                  />
                )}
                Doc No.
              </th>
              <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                {clickedColumn === 'code' ? (
                  <span
                    style={
                      clickedColumn === 'code'
                        ? {
                            borderRadius: '2px',
                            border: '1px solid black',
                            padding: 2,
                            marginRight: 2
                          }
                        : {}
                    }
                  >
                    <Image
                      src={sortCode ? sortDown : sortUp}
                      onClick={() => handleSortCode('code')}
                    />
                  </span>
                ) : (
                  <Image
                    className="fw-normal"
                    src={sortUp}
                    onClick={() => handleSortDoc('code')}
                  />
                )}
                Code
              </th>

              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: 120 }}
              >
                {clickedColumn === 'lastName' ? (
                  <span
                    style={
                      clickedColumn === 'lastName'
                        ? {
                            borderRadius: '2px',
                            border: '1px solid black',
                            padding: 2,
                            marginRight: 2
                          }
                        : {}
                    }
                  >
                    <Image
                      src={sortLastDate ? sortDown : sortUp}
                      onClick={() => handleSortLastDate('lastName')}
                    />
                  </span>
                ) : (
                  <Image
                    className="fw-normal"
                    src={sortUp}
                    onClick={() => handleSortLastDate('lastName')}
                  />
                )}
                Last Date
              </th>

              <th
                className="fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: 120 }}
              >
                {clickedColumn === 'name' ? (
                  <span
                    style={
                      clickedColumn === 'name'
                        ? {
                            borderRadius: '2px',
                            border: '1px solid black',
                            padding: 2,
                            marginRight: 2
                          }
                        : {}
                    }
                  >
                    <Image
                      src={sortName ? sortDown : sortUp}
                      onClick={() => handleSortName('name')}
                    />
                  </span>
                ) : (
                  <Image
                    className="fw-normal"
                    src={sortUp}
                    onClick={() => handleSortDoc('name')}
                  />
                )}
                Name
              </th>

              <th
                className="fw-normal  text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Department {/* แผนก */}
              </th>

              <th className="fw-normal" style={{ whiteSpace: 'nowrap' }}>
                Position
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Warehouse
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Accounting
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Finance
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                IT
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                PD
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Status
              </th>
              <th
                className="fw-normal text-center"
                style={{ whiteSpace: 'nowrap' }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {dataChecklist.length > 0 ? (
              dataChecklist.map((d, i) => (
                <tr key={i} className="fw-light font-small-2 align-middle">
                  <td> {page * totalLimits - totalLimits + i + 1}</td>
                  <td className="">{d.clr_no}</td>
                  <td className="">{d.code}</td>

                  <td className="text-center">
                    {d.last_date === '0000-00-00' ? (
                      <>-</>
                    ) : (
                      <>
                        {d.last_date
                          ? moment(d.last_date).format('DD/MM/YYYY')
                          : '-'}
                      </>
                    )}
                  </td>
                  <td className="">
                    <p className="mb-0  ">
                      {d.title_th}
                      {d.name_th} {d.surname_th}
                    </p>
                  </td>

                  <td className=" text-center">{d.department}</td>

                  <td className="">
                    {' '}
                    <p className="mb-0  ">{d.position_th} </p>
                  </td>
                  <td className="text-center">
                    {d.is_confirm1 === null ? (
                      <BsCircleFill size={25} style={{ color: '#adadad' }} />
                    ) : d.is_confirm1 === 0 ? (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: '#ff4141' }}
                      />
                    ) : (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: 'var(--comp-badge-color-background-primary)' }}
                      />
                    )}
                  </td>
                  <td className="text-center">
                    {d.is_confirm2 === null ? (
                      <BsCircleFill size={25} style={{ color: '#adadad' }} />
                    ) : d.is_confirm2 === 0 ? (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: '#ff4141' }}
                      />
                    ) : (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: 'var(--comp-badge-color-background-primary)' }}
                      />
                    )}
                  </td>
                  <td className="text-center">
                    {d.is_confirm3 === null ? (
                      <BsCircleFill size={25} style={{ color: '#adadad' }} />
                    ) : d.is_confirm3 === 0 ? (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: '#ff4141' }}
                      />
                    ) : (
                      <BsCheckCircleFill
                        size={25}
                        style={{ color: 'var(--comp-badge-color-background-primary)' }}
                      />
                    )}
                  </td>

                  <td className="text-center">
                    {d?.status_id === 3 || d?.status_id === 4 ? (
                      <span className="d-flex justify-content-center">
                        <Button
                          variant="btn btn-outline-primary"
                          className="border-0 d-flex "
                          size="sm"
                          style={{
                            width: '32px',
                            height: '32px'
                          }}
                        >
                          <Image
                            src={editImg3}
                            style={{
                              width: '20px'
                            }}
                          />
                        </Button>
                      </span>
                    ) : (
                      <>
                        {d.status_id === 2 && d.is_confirm4 === null ? (
                          <Button
                            variant="btn btn-outline-secondary"
                            className="border-0 d-flex "
                            size="sm"
                            style={{
                              width: '32px',
                              height: '32px'
                            }}
                            disabled
                          >
                            <Image
                              src={editImg3}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        ) : d.is_confirm4 === null ? (
                          <div className="d-flex justify-content-center">
                            <ButtonToolbar>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-detail">Edit</Tooltip>
                                }
                              >
                                <Button
                                  variant="btn btn-outline-primary"
                                  className="border-0 d-flex "
                                  size="sm"
                                  style={{
                                    width: '32px',
                                    height: '32px'
                                  }}
                                  onClick={() => hadleClickIT(d)}
                                >
                                  <Image
                                    src={editImg}
                                    style={{
                                      width: '20px'
                                    }}
                                  />
                                </Button>
                              </OverlayTrigger>
                            </ButtonToolbar>
                          </div>
                        ) : d.is_confirm4 === 2 ? (
                          <ButtonToolbar className="d-flex justify-content-center">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-detail">Edit</Tooltip>
                              }
                            >
                              <Button
                                variant="btn btn-outline-warning"
                                className="border-0 d-flex "
                                size="sm"
                                style={{
                                  width: '32px',
                                  height: '32px'
                                }}
                                onClick={() => hadleClickIT(d)}
                              >
                                <Image
                                  src={editImg2}
                                  style={{
                                    width: '20px'
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          </ButtonToolbar>
                        ) : d.is_confirm4 === 0 ? (
                          <BsCheckCircleFill
                            onClick={() => {
                              hadleClickIT(d)
                            }}
                            className="pointer-event"
                            size={25}
                            style={{ color: '#ff4141' }}
                          />
                        ) : (
                          <BsCheckCircleFill
                            onClick={() => {
                              hadleClickIT(d)
                            }}
                            className="pointer-event"
                            size={25}
                            style={{ color: 'var(--comp-badge-color-background-primary)' }}
                          />
                        )}
                      </>
                    )}
                  </td>
                  <td className="text-center">
                    <span className="d-flex justify-content-center">
                      {d.is_confirm6 === null ? (
                        <ButtonToolbar className="d-flex justify-content-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Edit</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex "
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => hadleClickAdmin(d)}
                            >
                              <Image
                                src={editImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      ) : d.is_confirm6 === 0 ? (
                        <BsCheckCircleFill
                          onClick={() => {
                            hadleClickAdmin(d)
                          }}
                          className="pointer-event"
                          size={25}
                          style={{ color: '#ff4141' }}
                        />
                      ) : (
                        <BsCheckCircleFill
                          onClick={() => {
                            hadleClickAdmin(d)
                          }}
                          className="pointer-event"
                          size={25}
                          style={{ color: 'var(--comp-badge-color-background-primary)' }}
                        />
                      )}
                    </span>
                  </td>

                  <td className="text-center">
                    <span
                      className={
                        d.status_id === 1
                          ? 'text-warning'
                          : d.status_id === 2
                            ? 'text-success'
                            : d.status_id === 3
                              ? 'text-danger'
                              : null
                      }
                    >
                      {d.status_en}
                    </span>
                  </td>

                  <td className="text-center">
                    {d.status_id === 1 ? (
                      <>
                        <ButtonToolbar className="d-flex justify-content-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Cancel</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => fnCancelCLN(d)}
                            >
                              <Image
                                src={cancelImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </>
                    ) : d.status_id === 2 ? (
                      <Button
                        variant="btn btn-outline-primary"
                        className="border-0 d-flex justify-content-center"
                        size="sm"
                        style={{
                          width: '32px',
                          height: '32px'
                        }}
                        disabled
                      >
                        <Image
                          src={cancelImg2}
                          style={{
                            width: '20px'
                          }}
                        />
                      </Button>
                    ) : d.status_id === 3 ? (
                      <>
                        <Button
                          variant="btn btn-outline-primary"
                          className="border-0 d-flex justify-content-center"
                          size="sm"
                          style={{
                            width: '32px',
                            height: '32px'
                          }}
                          disabled
                        >
                          <Image
                            src={cancelImg2}
                            style={{
                              width: '20px'
                            }}
                          />
                        </Button>
                      </>
                    ) : null}
                  </td>
                </tr>
              ))
            ) : !orgId ? (
              <tr className="mb-0">
                <td className="text-center small" colSpan={13}>
                  - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                </td>
              </tr>
            ) : isLoading ? (
              <tr className="mb-0">
                <td className="text-center" colSpan={14}>
                  <SpinnerLoading />
                </td>
              </tr>
            ) : (
              <tr className="mb-0">
                <td className="text-center" colSpan={14}>
                  -ไม่มีข้อมูล-
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    </>
  )
}
